<input [gcSelectOnClick]="true"
  class="input-field"
  type="number"
  step="1"
  [min]="min"
  [max]="max"
  [formControl]="formControl"
  [class.error]="hasError || isRejected">

@if (totalPrice) {
  <span>{{totalPrice | currency}}</span>
}

<div class="validation-message-container">
  @if (formControl.hasError('max')) {
    <p
      class="validation-message">
      Max Qty is {{max}}
    </p>
  }

  @if (formControl.hasError('min')) {
    <p
      class="validation-message">
      Min Qty is {{min}}
    </p>
  }

  @if (formControl.hasError('pattern')) {
    <p
      class="validation-message">
      Whole numbers only
    </p>
  }
</div>
